import authenticatedHttpClientFactory from '@/modules/core/services/authenticatedHttpClientFactory';
import { computed, ref } from 'vue';
import { i18n } from '../localization';

export const getProfile = () => {
  if (localStorage.getItem('access_token')) {
    return {
      name: localStorage.getItem('username'),
      email: localStorage.getItem('email'),
      profile: localStorage.getItem('profile'),
      profileName: parseInt(localStorage.getItem('profile')) ? ref(computed(_ => i18n.global.t("usuario"))) : ref(computed(_ => i18n.global.t("administrador"))),
    };
  } else if (sessionStorage.getItem('access_token')) {
    return {
      name: sessionStorage.getItem('username'),
      email: sessionStorage.getItem('email'),
      profile: sessionStorage.getItem('profile'),
profileName: parseInt(sessionStorage.getItem('profile')) ? ref(computed(_ => i18n.global.t("usuario"))) : ref(computed(_ => i18n.global.t("administrador"))),
    };
  }
};

export const updateProfile = async(oldPassword, newPassword) => {
  try {
    const httpClient = authenticatedHttpClientFactory();
    await httpClient.patch('profile', { oldPassword, newPassword });
    return true;
  } catch (error) {
    if (error.response.status === 400) {
      return false;
    }
    throw error;
  }
};
